import React from 'react';
import {
  BarChart,
  Bar,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

import {
  numberDivisions,
  capitalizeFirstLetter
} from '../../helpers';

const CustomTooltip = ({
   active,
   payload,
   label,
   XAxisDataKey,
   bars,
 }) => {
  if (active && !!payload) {
    return (
      <div className="custom-tooltip">
        <p className="intro">{capitalizeFirstLetter(XAxisDataKey)}: {label}</p>
        {bars.length > 0 && bars.map((bar, index) => <p className="desc" key={bar.name} style={{'color': bar.fill}}>{bar.name}: {numberDivisions(payload[index].value)}</p>)}
        {bars.length > 0 && bars.map((bar, index) => {
          return (
            bar.tooltipOptions !== undefined && bar.tooltipOptions.map(({ id, shortName, name, suffix }) => {
              return (
                <p
                  key={id}
                  className="desc"
                >
                  {name}: {suffix ? payload[index].payload[shortName] + suffix : numberDivisions(payload[index].payload[shortName])}
                </p>
              );
            })
          );
        })}
      </div>
    );
  }

  return null;
};

const Graph = ({
    data,
    bars,
    XAxisDataKey,
    tickXAxis = true,
    showLegend = true
  }) => {
  return (
    <ResponsiveContainer width={'99%'} height={400}>
      <BarChart data={data||[]}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={XAxisDataKey} tick={tickXAxis} />
        <YAxis />
        <Tooltip
          cursor={{ fill: 'transparent' }}
          content={
            <CustomTooltip
              XAxisDataKey={XAxisDataKey}
              bars={bars}
            />
          }
        />
        {showLegend && <Legend />}
        {bars.length > 0 && bars.map(({ name, dataKey, fill }) => (
          <Bar
            dataKey={dataKey}
            key={name}
            fill={fill}
            name={name}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  )
};

export default Graph;
